<template>
	<div class="class">
		<teacherHeader :logo_name="logo_name" @info-event="myInfoEvent" @public-event="publicEvent"></teacherHeader>
		<div class="task_cont bg_blue">
			<div class="task_cont_div bg_white radius8 bs">
				<div class="task_cont_nav f18px cl_dark">
					<router-link :to="item.url" class="task_cont_nav_list" v-for="(item,index) in nav" :key="index" :class="{'on': item.id == nav_cur}">{{item.name}}</router-link>
				</div>
				<div class="task_subject cl_gray tc">
					<span class="task_subject_list bg_gray cur" v-for="(item,index) in subject" :key="index"
					 @click="subjectCheck(item.subjectName)" :class="{'on': subject_cur == item.subjectName}">{{item.subjectName}}</span>
				</div>
				<div class="task_paper_screen mat30">
					<div class="test_screen cl_gray">
						<div class="test_screen_l f16px"><span class="inline">年级</span><i class="inline">：</i></div>
						<div class="test_screen_r tc">
							<span class="test_screen_list bg_gray" v-for="(item,index) in grade" :key="index" :class="{'on':item==grade_cur}" @click="gradeCheck(item)">{{item}}</span>
						</div>
					</div>
					<div class="test_screen cl_gray">
						<div class="test_screen_l f16px"><span class="inline">类型</span><i class="inline">：</i></div>
						<div class="test_screen_r tc">
							<span class="test_screen_list bg_gray" v-for="(item,index) in type" :key="index" :class="{'on':item==type_cur}" @click="typeCheck(item)">{{item}}</span>
						</div>
					</div>
				</div>
				<div class="f18px cl_gray mat30">共 <span class="cl_yel">{{total}}</span> 个课程</div>
				<div class="task_paper_cont mat20">
					<div class="task_video_list radius8 bs" v-for="(item,index) in list" :key="index">
						<div class="task_video_list_top flex">
							<div class="task_video_list_l flex">
								<router-link :to="{ path: '/video', query: { id: item.id}}" class="task_video_list_img"><img :src="item.pic" class="block" /></router-link>
								<div class="task_video_list_text">
									<div class="task_video_list_text_title">
										<span class="cl_white tc mar10" :class="[{'increase':item.direction=='提高'},{'notch':item.direction=='拔尖'}]">{{item.direction}}</span>
										<router-link :to="{ path: '/video', query: { id: item.id}}" class="f20px">{{item.name}}</router-link>
									</div>
									<p class="cl_dark mat10"><span class="cl_gray">主讲老师：</span>{{item.teacher_name}}</p>
									<p class="cl_dark mat10"><span class="cl_gray">播放：</span>{{item.browse_num}}</p>
								</div>
							</div>
							<div class="task_video_list_r tc">
								<div class="task_video_list_r_add radius20 cur f18px cl_white tc on" v-if="item.is_exist == 1">整包移出作业篮</div>
								<div class="task_video_list_r_add radius20 cur f18px cl_white tc" v-else>+整包加入作业篮</div>
								<p class="cl_gray mat40">已添加<span class="cl_yel">{{item.check_num}}</span>讲</p>
							</div>
						</div>
					</div>
				</div>
				<div class="famous_page flex" v-if="list.length > 0">
					<div class="famous_page_l f16px cl_gray"> </div>
					<div class="famous_page_r cl_dark">
						<el-pagination background layout="prev, pager, next, jumper"
						@current-change="handleCurrentChange" :page-size="pageSize" :current-page="currentPage" :total="total"></el-pagination>
					</div>
				</div>
				<div class="choice_empty tc f18px cl_gray" v-if="list.length == 0">
					<p>找不到内容，请重新选择</p>
				</div>
			</div>
		</div>
		<!-- 作业篮 -->
		<router-link to="/basket" class="basket">
			<el-popover placement="bottom-start" trigger="hover">
				<div class="basket_hide">
					<table class="basket_hide_cont f16px">
						<tr class="basket_hide_item cl_dark">
							<td align="center">学科</td>
							<td align="center">视频</td>
							<td align="center">作业</td>
						</tr>
						<tr class="basket_hide_item cl_gray" v-for="(item,index) in basket.list" :key="index">
							<td align="center">{{item.subject}}</td>
							<td align="center">{{item.video == null || item.video == "" ? "-" : item.video}}</td>
							<td align="center">{{item.task == null || item.task == "" ? "-" : item.task}}</td>
						</tr>
					</table>
					<div class="tc mat10">
						<router-link to="/basket" class="cl_blue">预览预选作业 ></router-link>
					</div>
				</div>
				<el-button slot="reference" class="basket_link">
					<img src="../../../static/basket_icon.png" />
					<div class="basket_link_text cl_white">
						<p class="f20px">作业篮</p>
						<p class="f16px mat5"><span class="cl_yel">{{basket.num}}</span>项内容</p>
					</div>
				</el-button>
			</el-popover>
		</router-link>
	</div>
</template>

<script>
	import teacherHeader from '../../components/teacher_header.vue'
	
	export default {
		name: 'school_video',
		components: {
			teacherHeader,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				logo_name: "校本作业资源库",
				nav: [
					{
						id: 1,
						name: "校本视频",
						url: "/school_video",
					},{
						id: 2,
						name: "校本试卷",
						url: "/school_paper",
					},
				],
				nav_cur: 1,
				subject: [], //学科
				subject_cur: "",
				grade: [], //年级
				grade_cur: "",
				type: [], //类型
				type_cur: "",
				list: [],
				currentPage: 1, //当前页数
				pageSize: 20, //每页数量
				total: 0, //总页数
				basket: {
					num: 1,
					list: [
						{
							subject: "语文",
							video: null,
							task: 1,
						},{
							subject: "数学",
							video: 2,
							task: 1,
						},
					],
				}, //作业篮
				
			}
		},
		created() {
			
		},
		mounted() {
			this.getSubject();
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			//学科
			getSubject () {
				this.$get("/api/material/get_subject_data",{})
				.then(res => {
					this.subject = res.data;
					this.subject_cur = this.subject[0].subjectName;
					this.getGrade();
				});
			},
			//年级
			getGrade () {
				this.$get("/api/funlearning/get_grade_data",{})
				.then(res => {
					this.grade = res.data;
					this.grade_cur = this.grade[0];
					this.getType();
				});
			},
			//类型
			getType () {
				this.$get("/api/funlearning/get_paper_type_data",{})
				.then(res => {
					this.type = res.data;
					this.type.unshift("全部");
					this.type_cur = this.type[0];
					this.getList();
				});
			},
			//视频
			getList () {
				// var type = "";
				// if (this.type_cur == "全部") {
				// 	type = "";
				// } else {
				// 	type = this.type_cur;
				// }
				// this.$get("/api/teacher/get_papers_work_list",{
				// 	token: localStorage.getItem("token"),
				// 	subject_name: this.subject_cur,
				// 	grade_name: this.grade_cur,
				// 	paper_type: type,
				// 	page: this.currentPage,
				// 	limit: this.pageSize,
				// })
				// .then(res => {
				// 	this.list = res.data.data;
				// 	this.total = res.data.total;
				// });
			},
			subjectCheck (e) {
				this.subject_cur = e;
				this.currentPage = 1;
				this.getList();
			},
			gradeCheck (e) {
				this.grade_cur = e;
				this.currentPage = 1;
				this.getList();
			},
			typeCheck (e) {
				this.type_cur = e;
				this.currentPage = 1;
				this.getList();
			},
			handleCurrentChange: function(currentPage){
				this.currentPage = currentPage;
				this.getList();
			},
		},
	}
</script>

<style>
</style>
